import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './Modal.module.css';

class Modal extends Component {
  render() {
    const { children, onConfirm, onClose } = this.props;

    const confirmDisabled = !onConfirm;
    return (
      <div className={style.modal}>
        <div className={style.background} onClick={this.close} />
        <div className={style.content}>
          { children }
          <hr />
          <div className={style.buttons}>
            <button className={`btn ${style.btn}`} onClick={onClose}>
              <i className="fas fa-fw fa-trash" /> Cancel
            </button>
            <button className={`btn btn-primary ${style.btn}`} onClick={onConfirm} disabled={confirmDisabled}>
              <i className="fas fa-fw fa-check" /> Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

export default Modal;
